import { PreviewCard } from '@src/components/dynamicSelector/PreviewCard';

interface FitFactPreviewCardProps {
  text: string;
  source?: {
    url?: string;
    source?: string;
    title?: string;
  };
}

// The FitFact list already carries the whole text and its source, so the
// hover preview needs no request. Rows clamp to two lines; this shows it all.
export const FitFactPreviewCard = ({ text, source }: FitFactPreviewCardProps) => {
  const sourceLabel = [source?.title, source?.source, source?.url].find(Boolean);

  return (
    <PreviewCard title="FitFact">
      <p className="whitespace-pre-line break-words font-light text-gray-700">{text}</p>
      {sourceLabel && (
        <div className="mt-3 break-words text-xs text-label-foreground">
          Source:{' '}
          {source?.url
            ? <a href={source.url} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{sourceLabel}</a>
            : sourceLabel}
        </div>
      )}
    </PreviewCard>
  );
};
